import React, { FC } from 'react';
import EntityFilesTable, { EntityFilesTablePropsType } from 'src/components/FileUpload/EntityFilesTable';
import { RECEIVING_FILE_DESCRIPTION_MAX_LENGTH } from 'src/utils/receivingFiles';

export type ReceivingFilesListPropsType = Pick<
    EntityFilesTablePropsType,
    'files' | 'disabled' | 'onDescriptionChange' | 'onDeleteFile' | 'skladonUser'
>;

const ReceivingFilesList: FC<ReceivingFilesListPropsType> = (props) => (
    <EntityFilesTable
        {...props}
        showDescription
        descriptionMaxLength={RECEIVING_FILE_DESCRIPTION_MAX_LENGTH}
        testIdPrefix="receiving-files"
    />
);

export default ReceivingFilesList;
